/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProvisioningInputs */

const en_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provisioning...`)
};

const es_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovisionando...`)
};

const fr_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provisionnement...`)
};

const de_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird bereitgestellt...`)
};

const ja_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロビジョニング中...`)
};

const zh_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在配置...`)
};

const ar_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري التجهيز...`)
};

const id_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyediakan...`)
};

const it_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provisioning in corso...`)
};

const ru_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предоставление...`)
};

const pt_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provisionando...`)
};

const ko_provisioning = /** @type {(inputs: ProvisioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로비저닝 중...`)
};

/**
* | output |
* | --- |
* | "Provisioning..." |
*
* @param {ProvisioningInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const provisioning = /** @type {((inputs?: ProvisioningInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProvisioningInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_provisioning(inputs)
	if (locale === "es") return es_provisioning(inputs)
	if (locale === "fr") return fr_provisioning(inputs)
	if (locale === "de") return de_provisioning(inputs)
	if (locale === "ja") return ja_provisioning(inputs)
	if (locale === "zh") return zh_provisioning(inputs)
	if (locale === "ar") return ar_provisioning(inputs)
	if (locale === "id") return id_provisioning(inputs)
	if (locale === "it") return it_provisioning(inputs)
	if (locale === "ru") return ru_provisioning(inputs)
	if (locale === "pt") return pt_provisioning(inputs)
	return ko_provisioning(inputs)
});